import { Fragment } from "react";
import { useFields } from "../../hooks/use-fields";
import { BoxConnector } from "../Box";
import Rule from "./Rule";
import { EditableMessageTemplateRule } from ".";
import { OnChange } from "../../hooks/use-optional-state";

type Props = {
  value: EditableMessageTemplateRule[];
  onChange: OnChange<EditableMessageTemplateRule[]>;
};

function Rules({ value, onChange }: Props) {
  const { field, value: rules } = useFields({ value, onChange });

  const remove = (index: number) => () => {
    onChange((templates) =>
      templates.map((item, i) =>
        i !== index ? item : { ...item, _destroy: true }
      )
    );
  };

  return (
    <>
      {rules.map((rule, index) =>
        rule._destroy ? null : (
          <Fragment key={rule.tempId || rule.id}>
            <BoxConnector />
            <Rule {...field(index)} onRemove={remove(index)} />
          </Fragment>
        )
      )}
    </>
  );
}

export default Rules;
